/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    background: {
      description: 'Background colour of box. Transparent if not specified.',
      type: 'variant',
      values: [
        'lightest',         'lighter',
        'light',            'dark',
        'darker',           'darkest',
        'critical',         'danger',
        'warning',          'positive',
        'brand',            'white',
        'black',            'purpleGradient',
        'greenGradient',    'neutralGradient',
        'brandGradient',    'featurePrimary',
        'featureSecondary', 'featureNeutral',
        'featureBrand'
      ]
    }
  },
  rules: [
    {
      if: { background: 'lightest' },
      tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
    },
    {
      if: { background: 'lighter' },
      tokens: { backgroundColor: '#fafafa', borderColor: '#fafafa' }
    },
    {
      if: { background: 'light' },
      tokens: { backgroundColor: '#f4f4f7', borderColor: '#f4f4f7' }
    },
    {
      if: { background: 'dark' },
      tokens: { backgroundColor: '#414547', borderColor: '#414547' }
    },
    {
      if: { background: 'darker' },
      tokens: { backgroundColor: '#2c2e30', borderColor: '#2c2e30' }
    },
    {
      if: { background: 'darkest' },
      tokens: { backgroundColor: '#000000', borderColor: '#000000' }
    },
    {
      if: { background: 'critical' },
      tokens: { backgroundColor: '#c12335', borderColor: '#c12335' }
    },
    {
      if: { background: 'danger' },
      tokens: { backgroundColor: '#fff6f8', borderColor: '#fff6f8' }
    },
    {
      if: { background: 'warning' },
      tokens: { backgroundColor: '#fff9ee', borderColor: '#fff9ee' }
    },
    {
      if: { background: 'positive' },
      tokens: { backgroundColor: '#f4f9f2', borderColor: '#f4f9f2' }
    },
    {
      if: { background: 'brand' },
      tokens: { backgroundColor: '#4b286d', borderColor: '#4b286d' }
    },
    {
      if: { background: 'white' },
      tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
    },
    {
      if: { background: 'black' },
      tokens: { backgroundColor: '#000000', borderColor: '#000000' }
    },
    {
      if: { background: 'brandGradient' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#613889', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'greenGradient' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#00784a', hint: 0.75, stop: 0 },
            { color: '#66cc00', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'neutralGradient' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 180,
          stops: [
            { color: '#ffffff', stop: 0 },
            { color: '#f4f4f7', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'purpleGradient' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'featurePrimary' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'featureSecondary' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#00784a', hint: 0.75, stop: 0 },
            { color: '#66cc00', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'featureNeutral' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 180,
          stops: [
            { color: '#ffffff', stop: 0 },
            { color: '#f4f4f7', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'featureBrand' },
      tokens: {
        backgroundColor: null,
        borderColor: null,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#613889', stop: 1 }
          ],
          type: 'linear'
        }
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: null,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    gradient: null
  }
}
export default theme
